var map = {
	"./batsu.png": "d5ac",
	"./batsu_blue.png": "14c6",
	"./cloud_up.png": "02c7",
	"./direction_horizon.png": "32bf",
	"./direction_vertiical.png": "f9e5",
	"./flick_down.png": "62b5",
	"./flick_left.png": "55efd",
	"./flick_right.png": "1b25",
	"./gokaku.png": "aec7",
	"./homework_returned.png": "a4bf",
	"./homework_scoring.png": "5a66",
	"./icon_ai_logo.png": "d973",
	"./icon_ai_processing.png": "25ce",
	"./icon_cursor.png": "4ed5",
	"./icon_manual.png": "2ca1",
	"./icon_mark_gray.png": "6eba",
	"./icon_mark_green.png": "f46e",
	"./icon_mark_position.png": "fc01",
	"./icon_rotate_left.png": "2f61",
	"./icon_rotate_right.png": "1272",
	"./icon_waku_assign.png": "f561",
	"./icon_waku_auto.png": "769c",
	"./icon_waku_manual.png": "a09f",
	"./icon_waku_reset.png": "bb4b",
	"./keyboard_1.png": "97dc",
	"./keyboard_2.png": "9f8a",
	"./keyboard_3.png": "6fd0",
	"./keyboard_4.png": "5246",
	"./keyboard_5.png": "9e38",
	"./keyboard_6.png": "2e80",
	"./keyboard_7.png": "386f",
	"./keyboard_8.png": "d01c",
	"./keyboard_9.png": "7767",
	"./keyboard_A.png": "75b8",
	"./keyboard_Arrow.png": "ab31",
	"./keyboard_Arrow_Down.png": "c796",
	"./keyboard_Arrow_Left.png": "e88b",
	"./keyboard_Arrow_Left_Right.png": "0c39",
	"./keyboard_Arrow_Right.png": "7590",
	"./keyboard_Arrow_Up.png": "5bec",
	"./keyboard_B.png": "db7d",
	"./keyboard_Backspace.png": "9fa5",
	"./keyboard_C.png": "59c1",
	"./keyboard_Ctrl.png": "3ffd",
	"./keyboard_D.png": "badb",
	"./keyboard_E.png": "4737",
	"./keyboard_Enter.png": "122c",
	"./keyboard_F.png": "67ea",
	"./keyboard_G.png": "e6fe",
	"./keyboard_H.png": "9bd9",
	"./keyboard_M.png": "ce52",
	"./keyboard_Minus.png": "692c",
	"./keyboard_ModeArea.png": "d46c",
	"./keyboard_N.png": "3d4f",
	"./keyboard_O.png": "4f40",
	"./keyboard_P.png": "e1fd",
	"./keyboard_Plus.png": "ca5a",
	"./keyboard_Q.png": "04f7",
	"./keyboard_S.png": "3657",
	"./keyboard_SaitenInputModeArea.png": "f847",
	"./keyboard_Shift.png": "4c25",
	"./keyboard_T.png": "7839",
	"./keyboard_V.png": "a6c1",
	"./keyboard_W.png": "fa77",
	"./keyboard_X.png": "c53e",
	"./keyboard_Z.png": "c7fc",
	"./logo_smarky_entrance_ol.png": "45ab",
	"./logo_smarky_ol.png": "3912",
	"./maru.png": "1c95",
	"./maru_blue.png": "a794",
	"./microsoft_access_permissions_consent_screen.png": "f2b2",
	"./microsoft_account_selection_screen.png": "4000",
	"./microsoft_admin_consent_required_screen.png": "da2d",
	"./saiten.png": "9514",
	"./sankaku.png": "ff4a",
	"./sankaku_blue.png": "458b",
	"./sankaku_score/sankaku_100_blue.png": "daa5",
	"./sankaku_score/sankaku_100_red.png": "fec3",
	"./sankaku_score/sankaku_10_blue.png": "0f3c",
	"./sankaku_score/sankaku_10_red.png": "249a",
	"./sankaku_score/sankaku_11_blue.png": "efe2",
	"./sankaku_score/sankaku_11_red.png": "94ba",
	"./sankaku_score/sankaku_12_blue.png": "5d63",
	"./sankaku_score/sankaku_12_red.png": "9d17",
	"./sankaku_score/sankaku_13_blue.png": "2fe6",
	"./sankaku_score/sankaku_13_red.png": "e368",
	"./sankaku_score/sankaku_14_blue.png": "5d30",
	"./sankaku_score/sankaku_14_red.png": "12e3",
	"./sankaku_score/sankaku_15_blue.png": "06f2",
	"./sankaku_score/sankaku_15_red.png": "2725",
	"./sankaku_score/sankaku_16_blue.png": "a6fd",
	"./sankaku_score/sankaku_16_red.png": "91b3",
	"./sankaku_score/sankaku_17_blue.png": "0e00",
	"./sankaku_score/sankaku_17_red.png": "e4d8",
	"./sankaku_score/sankaku_18_blue.png": "4e40",
	"./sankaku_score/sankaku_18_red.png": "7a82",
	"./sankaku_score/sankaku_19_blue.png": "f78f",
	"./sankaku_score/sankaku_19_red.png": "e339",
	"./sankaku_score/sankaku_1_blue.png": "7b68",
	"./sankaku_score/sankaku_1_red.png": "eefb",
	"./sankaku_score/sankaku_20_blue.png": "e075",
	"./sankaku_score/sankaku_20_red.png": "6e7d",
	"./sankaku_score/sankaku_21_blue.png": "b9e9",
	"./sankaku_score/sankaku_21_red.png": "1822",
	"./sankaku_score/sankaku_22_blue.png": "a916",
	"./sankaku_score/sankaku_22_red.png": "3b2c",
	"./sankaku_score/sankaku_23_blue.png": "3c3d",
	"./sankaku_score/sankaku_23_red.png": "81aa",
	"./sankaku_score/sankaku_24_blue.png": "c1ff",
	"./sankaku_score/sankaku_24_red.png": "3518",
	"./sankaku_score/sankaku_25_blue.png": "b396",
	"./sankaku_score/sankaku_25_red.png": "eaa5",
	"./sankaku_score/sankaku_26_blue.png": "a164",
	"./sankaku_score/sankaku_26_red.png": "08e0",
	"./sankaku_score/sankaku_27_blue.png": "7ea1",
	"./sankaku_score/sankaku_27_red.png": "1674",
	"./sankaku_score/sankaku_28_blue.png": "d0eb",
	"./sankaku_score/sankaku_28_red.png": "27e2",
	"./sankaku_score/sankaku_29_blue.png": "5aad",
	"./sankaku_score/sankaku_29_red.png": "5f89",
	"./sankaku_score/sankaku_2_blue.png": "360c",
	"./sankaku_score/sankaku_2_red.png": "add2",
	"./sankaku_score/sankaku_30_blue.png": "09cc",
	"./sankaku_score/sankaku_30_red.png": "43f2",
	"./sankaku_score/sankaku_31_blue.png": "fd98",
	"./sankaku_score/sankaku_31_red.png": "680e",
	"./sankaku_score/sankaku_32_blue.png": "b4c9",
	"./sankaku_score/sankaku_32_red.png": "3183",
	"./sankaku_score/sankaku_33_blue.png": "405e",
	"./sankaku_score/sankaku_33_red.png": "ebe6",
	"./sankaku_score/sankaku_34_blue.png": "4e9c",
	"./sankaku_score/sankaku_34_red.png": "a90b",
	"./sankaku_score/sankaku_35_blue.png": "9d33",
	"./sankaku_score/sankaku_35_red.png": "c00d",
	"./sankaku_score/sankaku_36_blue.png": "f066",
	"./sankaku_score/sankaku_36_red.png": "193b",
	"./sankaku_score/sankaku_37_blue.png": "a472",
	"./sankaku_score/sankaku_37_red.png": "175f",
	"./sankaku_score/sankaku_38_blue.png": "30dd",
	"./sankaku_score/sankaku_38_red.png": "803e",
	"./sankaku_score/sankaku_39_blue.png": "2f9b",
	"./sankaku_score/sankaku_39_red.png": "fa7e",
	"./sankaku_score/sankaku_3_blue.png": "3b7c",
	"./sankaku_score/sankaku_3_red.png": "f24e",
	"./sankaku_score/sankaku_40_blue.png": "0e27",
	"./sankaku_score/sankaku_40_red.png": "6d7d",
	"./sankaku_score/sankaku_41_blue.png": "058a",
	"./sankaku_score/sankaku_41_red.png": "8727",
	"./sankaku_score/sankaku_42_blue.png": "3ff2",
	"./sankaku_score/sankaku_42_red.png": "c5ce",
	"./sankaku_score/sankaku_43_blue.png": "8377",
	"./sankaku_score/sankaku_43_red.png": "e648",
	"./sankaku_score/sankaku_44_blue.png": "8d16",
	"./sankaku_score/sankaku_44_red.png": "93c7",
	"./sankaku_score/sankaku_45_blue.png": "ff57",
	"./sankaku_score/sankaku_45_red.png": "838d",
	"./sankaku_score/sankaku_46_blue.png": "7ba1",
	"./sankaku_score/sankaku_46_red.png": "4a2e",
	"./sankaku_score/sankaku_47_blue.png": "40d7",
	"./sankaku_score/sankaku_47_red.png": "c69a",
	"./sankaku_score/sankaku_48_blue.png": "f4d5",
	"./sankaku_score/sankaku_48_red.png": "90c2",
	"./sankaku_score/sankaku_49_blue.png": "51dc",
	"./sankaku_score/sankaku_49_red.png": "ef3a",
	"./sankaku_score/sankaku_4_blue.png": "ac28",
	"./sankaku_score/sankaku_4_red.png": "dc3c",
	"./sankaku_score/sankaku_50_blue.png": "234b",
	"./sankaku_score/sankaku_50_red.png": "329b",
	"./sankaku_score/sankaku_51_blue.png": "3ebe",
	"./sankaku_score/sankaku_51_red.png": "910c",
	"./sankaku_score/sankaku_52_blue.png": "977a",
	"./sankaku_score/sankaku_52_red.png": "9aaa",
	"./sankaku_score/sankaku_53_blue.png": "aaa6",
	"./sankaku_score/sankaku_53_red.png": "b68d",
	"./sankaku_score/sankaku_54_blue.png": "15c2",
	"./sankaku_score/sankaku_54_red.png": "2dd0",
	"./sankaku_score/sankaku_55_blue.png": "9528",
	"./sankaku_score/sankaku_55_red.png": "187d",
	"./sankaku_score/sankaku_56_blue.png": "80f9",
	"./sankaku_score/sankaku_56_red.png": "a0fe",
	"./sankaku_score/sankaku_57_blue.png": "f400",
	"./sankaku_score/sankaku_57_red.png": "8263",
	"./sankaku_score/sankaku_58_blue.png": "1bca",
	"./sankaku_score/sankaku_58_red.png": "1d7a",
	"./sankaku_score/sankaku_59_blue.png": "785e",
	"./sankaku_score/sankaku_59_red.png": "e57b",
	"./sankaku_score/sankaku_5_blue.png": "8e53",
	"./sankaku_score/sankaku_5_red.png": "8322",
	"./sankaku_score/sankaku_60_blue.png": "07fa",
	"./sankaku_score/sankaku_60_red.png": "e1a1",
	"./sankaku_score/sankaku_61_blue.png": "972f",
	"./sankaku_score/sankaku_61_red.png": "a64f",
	"./sankaku_score/sankaku_62_blue.png": "04ad",
	"./sankaku_score/sankaku_62_red.png": "c777",
	"./sankaku_score/sankaku_63_blue.png": "c53ed",
	"./sankaku_score/sankaku_63_red.png": "93b3",
	"./sankaku_score/sankaku_64_blue.png": "20d9",
	"./sankaku_score/sankaku_64_red.png": "1a9d",
	"./sankaku_score/sankaku_65_blue.png": "ccaf",
	"./sankaku_score/sankaku_65_red.png": "7625",
	"./sankaku_score/sankaku_66_blue.png": "14f9",
	"./sankaku_score/sankaku_66_red.png": "b1f0",
	"./sankaku_score/sankaku_67_blue.png": "8990",
	"./sankaku_score/sankaku_67_red.png": "cd19",
	"./sankaku_score/sankaku_68_blue.png": "953d",
	"./sankaku_score/sankaku_68_red.png": "1147",
	"./sankaku_score/sankaku_69_blue.png": "93f2",
	"./sankaku_score/sankaku_69_red.png": "a2ae",
	"./sankaku_score/sankaku_6_blue.png": "92de",
	"./sankaku_score/sankaku_6_red.png": "abed",
	"./sankaku_score/sankaku_70_blue.png": "c9a5",
	"./sankaku_score/sankaku_70_red.png": "b6dd",
	"./sankaku_score/sankaku_71_blue.png": "80df",
	"./sankaku_score/sankaku_71_red.png": "b745",
	"./sankaku_score/sankaku_72_blue.png": "76db",
	"./sankaku_score/sankaku_72_red.png": "cae6",
	"./sankaku_score/sankaku_73_blue.png": "a948",
	"./sankaku_score/sankaku_73_red.png": "287e",
	"./sankaku_score/sankaku_74_blue.png": "a84a",
	"./sankaku_score/sankaku_74_red.png": "4956",
	"./sankaku_score/sankaku_75_blue.png": "2fca",
	"./sankaku_score/sankaku_75_red.png": "38b6",
	"./sankaku_score/sankaku_76_blue.png": "9c52",
	"./sankaku_score/sankaku_76_red.png": "7921",
	"./sankaku_score/sankaku_77_blue.png": "87b1",
	"./sankaku_score/sankaku_77_red.png": "c557",
	"./sankaku_score/sankaku_78_blue.png": "2820",
	"./sankaku_score/sankaku_78_red.png": "e77d",
	"./sankaku_score/sankaku_79_blue.png": "44e0",
	"./sankaku_score/sankaku_79_red.png": "b444",
	"./sankaku_score/sankaku_7_blue.png": "ada4",
	"./sankaku_score/sankaku_7_red.png": "8d3f",
	"./sankaku_score/sankaku_80_blue.png": "2df2",
	"./sankaku_score/sankaku_80_red.png": "9dfe",
	"./sankaku_score/sankaku_81_blue.png": "9b1b",
	"./sankaku_score/sankaku_81_red.png": "60ba",
	"./sankaku_score/sankaku_82_blue.png": "4024",
	"./sankaku_score/sankaku_82_red.png": "5ced",
	"./sankaku_score/sankaku_83_blue.png": "4eec",
	"./sankaku_score/sankaku_83_red.png": "9692",
	"./sankaku_score/sankaku_84_blue.png": "2cbc",
	"./sankaku_score/sankaku_84_red.png": "d339",
	"./sankaku_score/sankaku_85_blue.png": "e954",
	"./sankaku_score/sankaku_85_red.png": "1f1b",
	"./sankaku_score/sankaku_86_blue.png": "6155",
	"./sankaku_score/sankaku_86_red.png": "cd8d",
	"./sankaku_score/sankaku_87_blue.png": "6f50b",
	"./sankaku_score/sankaku_87_red.png": "313c",
	"./sankaku_score/sankaku_88_blue.png": "68f8",
	"./sankaku_score/sankaku_88_red.png": "82e2",
	"./sankaku_score/sankaku_89_blue.png": "da36",
	"./sankaku_score/sankaku_89_red.png": "b5b1",
	"./sankaku_score/sankaku_8_blue.png": "44db",
	"./sankaku_score/sankaku_8_red.png": "d690",
	"./sankaku_score/sankaku_90_blue.png": "1f70",
	"./sankaku_score/sankaku_90_red.png": "af77",
	"./sankaku_score/sankaku_91_blue.png": "f409",
	"./sankaku_score/sankaku_91_red.png": "029d",
	"./sankaku_score/sankaku_92_blue.png": "27e3",
	"./sankaku_score/sankaku_92_red.png": "eb98",
	"./sankaku_score/sankaku_93_blue.png": "b29e",
	"./sankaku_score/sankaku_93_red.png": "639f",
	"./sankaku_score/sankaku_94_blue.png": "6b6e",
	"./sankaku_score/sankaku_94_red.png": "4f4a",
	"./sankaku_score/sankaku_95_blue.png": "962a",
	"./sankaku_score/sankaku_95_red.png": "a9d8",
	"./sankaku_score/sankaku_96_blue.png": "b671",
	"./sankaku_score/sankaku_96_red.png": "bb46",
	"./sankaku_score/sankaku_97_blue.png": "c7a4",
	"./sankaku_score/sankaku_97_red.png": "e7f7",
	"./sankaku_score/sankaku_98_blue.png": "290a",
	"./sankaku_score/sankaku_98_red.png": "1254",
	"./sankaku_score/sankaku_99_blue.png": "b13a",
	"./sankaku_score/sankaku_99_red.png": "67b4",
	"./sankaku_score/sankaku_9_blue.png": "3202",
	"./sankaku_score/sankaku_9_red.png": "0134",
	"./score_stamp/score_minus_100_blue.png": "40f9",
	"./score_stamp/score_minus_100_red.png": "90dd",
	"./score_stamp/score_minus_10_blue.png": "d646",
	"./score_stamp/score_minus_10_red.png": "a3d8",
	"./score_stamp/score_minus_11_blue.png": "eb91",
	"./score_stamp/score_minus_11_red.png": "348b",
	"./score_stamp/score_minus_12_blue.png": "84d9",
	"./score_stamp/score_minus_12_red.png": "7087",
	"./score_stamp/score_minus_13_blue.png": "f1b4",
	"./score_stamp/score_minus_13_red.png": "3f75",
	"./score_stamp/score_minus_14_blue.png": "4b1c",
	"./score_stamp/score_minus_14_red.png": "7677",
	"./score_stamp/score_minus_15_blue.png": "8ba1",
	"./score_stamp/score_minus_15_red.png": "edff",
	"./score_stamp/score_minus_16_blue.png": "99a5",
	"./score_stamp/score_minus_16_red.png": "37a2",
	"./score_stamp/score_minus_17_blue.png": "9b5b",
	"./score_stamp/score_minus_17_red.png": "96ce",
	"./score_stamp/score_minus_18_blue.png": "cabb",
	"./score_stamp/score_minus_18_red.png": "753f",
	"./score_stamp/score_minus_19_blue.png": "9b76",
	"./score_stamp/score_minus_19_red.png": "95d2",
	"./score_stamp/score_minus_1_blue.png": "9c8e",
	"./score_stamp/score_minus_1_red.png": "ada6",
	"./score_stamp/score_minus_20_blue.png": "4637",
	"./score_stamp/score_minus_20_red.png": "a04b",
	"./score_stamp/score_minus_21_blue.png": "4b28",
	"./score_stamp/score_minus_21_red.png": "274e",
	"./score_stamp/score_minus_22_blue.png": "952f",
	"./score_stamp/score_minus_22_red.png": "390d",
	"./score_stamp/score_minus_23_blue.png": "633d",
	"./score_stamp/score_minus_23_red.png": "91b9",
	"./score_stamp/score_minus_24_blue.png": "f331",
	"./score_stamp/score_minus_24_red.png": "8d33",
	"./score_stamp/score_minus_25_blue.png": "eaef",
	"./score_stamp/score_minus_25_red.png": "335a",
	"./score_stamp/score_minus_26_blue.png": "664d",
	"./score_stamp/score_minus_26_red.png": "a78a",
	"./score_stamp/score_minus_27_blue.png": "bd48",
	"./score_stamp/score_minus_27_red.png": "4765",
	"./score_stamp/score_minus_28_blue.png": "b1f5",
	"./score_stamp/score_minus_28_red.png": "78f1",
	"./score_stamp/score_minus_29_blue.png": "5209",
	"./score_stamp/score_minus_29_red.png": "6ee6",
	"./score_stamp/score_minus_2_blue.png": "7e27",
	"./score_stamp/score_minus_2_red.png": "12a4",
	"./score_stamp/score_minus_30_blue.png": "20ff",
	"./score_stamp/score_minus_30_red.png": "5d61",
	"./score_stamp/score_minus_31_blue.png": "1ed1",
	"./score_stamp/score_minus_31_red.png": "4f67",
	"./score_stamp/score_minus_32_blue.png": "013e",
	"./score_stamp/score_minus_32_red.png": "99ff",
	"./score_stamp/score_minus_33_blue.png": "790d",
	"./score_stamp/score_minus_33_red.png": "1eb7",
	"./score_stamp/score_minus_34_blue.png": "2ac8",
	"./score_stamp/score_minus_34_red.png": "9256",
	"./score_stamp/score_minus_35_blue.png": "6a59",
	"./score_stamp/score_minus_35_red.png": "083a",
	"./score_stamp/score_minus_36_blue.png": "1c68",
	"./score_stamp/score_minus_36_red.png": "6580",
	"./score_stamp/score_minus_37_blue.png": "6f69",
	"./score_stamp/score_minus_37_red.png": "85f8",
	"./score_stamp/score_minus_38_blue.png": "ee7d",
	"./score_stamp/score_minus_38_red.png": "c724",
	"./score_stamp/score_minus_39_blue.png": "46e6",
	"./score_stamp/score_minus_39_red.png": "d84e",
	"./score_stamp/score_minus_3_blue.png": "1853",
	"./score_stamp/score_minus_3_red.png": "fc2d",
	"./score_stamp/score_minus_40_blue.png": "9023",
	"./score_stamp/score_minus_40_red.png": "8eb6",
	"./score_stamp/score_minus_41_blue.png": "b934",
	"./score_stamp/score_minus_41_red.png": "6a51",
	"./score_stamp/score_minus_42_blue.png": "9369",
	"./score_stamp/score_minus_42_red.png": "5a42",
	"./score_stamp/score_minus_43_blue.png": "1a8b",
	"./score_stamp/score_minus_43_red.png": "f057",
	"./score_stamp/score_minus_44_blue.png": "260a",
	"./score_stamp/score_minus_44_red.png": "362e",
	"./score_stamp/score_minus_45_blue.png": "62c1",
	"./score_stamp/score_minus_45_red.png": "14e5",
	"./score_stamp/score_minus_46_blue.png": "f8b1",
	"./score_stamp/score_minus_46_red.png": "cb0f",
	"./score_stamp/score_minus_47_blue.png": "6a24",
	"./score_stamp/score_minus_47_red.png": "768e",
	"./score_stamp/score_minus_48_blue.png": "7e0f",
	"./score_stamp/score_minus_48_red.png": "9189",
	"./score_stamp/score_minus_49_blue.png": "5f44",
	"./score_stamp/score_minus_49_red.png": "8ed5",
	"./score_stamp/score_minus_4_blue.png": "0319",
	"./score_stamp/score_minus_4_red.png": "667d",
	"./score_stamp/score_minus_50_blue.png": "0626",
	"./score_stamp/score_minus_50_red.png": "b098",
	"./score_stamp/score_minus_51_blue.png": "f105",
	"./score_stamp/score_minus_51_red.png": "bc9a",
	"./score_stamp/score_minus_52_blue.png": "628e",
	"./score_stamp/score_minus_52_red.png": "29b1",
	"./score_stamp/score_minus_53_blue.png": "4a8b",
	"./score_stamp/score_minus_53_red.png": "b03c",
	"./score_stamp/score_minus_54_blue.png": "ce17",
	"./score_stamp/score_minus_54_red.png": "f3cd",
	"./score_stamp/score_minus_55_blue.png": "98f7",
	"./score_stamp/score_minus_55_red.png": "ad82",
	"./score_stamp/score_minus_56_blue.png": "1b14",
	"./score_stamp/score_minus_56_red.png": "f0c4",
	"./score_stamp/score_minus_57_blue.png": "e1fb",
	"./score_stamp/score_minus_57_red.png": "19f3",
	"./score_stamp/score_minus_58_blue.png": "2a0c",
	"./score_stamp/score_minus_58_red.png": "4ede",
	"./score_stamp/score_minus_59_blue.png": "e2dd",
	"./score_stamp/score_minus_59_red.png": "62a1",
	"./score_stamp/score_minus_5_blue.png": "bc78",
	"./score_stamp/score_minus_5_red.png": "dd16",
	"./score_stamp/score_minus_60_blue.png": "25c6",
	"./score_stamp/score_minus_60_red.png": "a902",
	"./score_stamp/score_minus_61_blue.png": "f524",
	"./score_stamp/score_minus_61_red.png": "8d63",
	"./score_stamp/score_minus_62_blue.png": "b637",
	"./score_stamp/score_minus_62_red.png": "7604",
	"./score_stamp/score_minus_63_blue.png": "900b",
	"./score_stamp/score_minus_63_red.png": "8fd3",
	"./score_stamp/score_minus_64_blue.png": "6dcd",
	"./score_stamp/score_minus_64_red.png": "7511",
	"./score_stamp/score_minus_65_blue.png": "9355",
	"./score_stamp/score_minus_65_red.png": "50f8",
	"./score_stamp/score_minus_66_blue.png": "a8a7",
	"./score_stamp/score_minus_66_red.png": "954c",
	"./score_stamp/score_minus_67_blue.png": "fc1f",
	"./score_stamp/score_minus_67_red.png": "90c6",
	"./score_stamp/score_minus_68_blue.png": "8e17",
	"./score_stamp/score_minus_68_red.png": "818f",
	"./score_stamp/score_minus_69_blue.png": "4700",
	"./score_stamp/score_minus_69_red.png": "a025",
	"./score_stamp/score_minus_6_blue.png": "4b1e",
	"./score_stamp/score_minus_6_red.png": "e02f",
	"./score_stamp/score_minus_70_blue.png": "5dd4",
	"./score_stamp/score_minus_70_red.png": "91e7",
	"./score_stamp/score_minus_71_blue.png": "206d",
	"./score_stamp/score_minus_71_red.png": "04ee",
	"./score_stamp/score_minus_72_blue.png": "41cd",
	"./score_stamp/score_minus_72_red.png": "1e5a",
	"./score_stamp/score_minus_73_blue.png": "75ea",
	"./score_stamp/score_minus_73_red.png": "452a",
	"./score_stamp/score_minus_74_blue.png": "8085",
	"./score_stamp/score_minus_74_red.png": "6255",
	"./score_stamp/score_minus_75_blue.png": "1050",
	"./score_stamp/score_minus_75_red.png": "f3f6",
	"./score_stamp/score_minus_76_blue.png": "6fe4",
	"./score_stamp/score_minus_76_red.png": "4f67e",
	"./score_stamp/score_minus_77_blue.png": "6c97",
	"./score_stamp/score_minus_77_red.png": "680f",
	"./score_stamp/score_minus_78_blue.png": "4977",
	"./score_stamp/score_minus_78_red.png": "2dc1e",
	"./score_stamp/score_minus_79_blue.png": "0296",
	"./score_stamp/score_minus_79_red.png": "068e",
	"./score_stamp/score_minus_7_blue.png": "cf23",
	"./score_stamp/score_minus_7_red.png": "891d",
	"./score_stamp/score_minus_80_blue.png": "2e8e",
	"./score_stamp/score_minus_80_red.png": "d2e6",
	"./score_stamp/score_minus_81_blue.png": "efbd",
	"./score_stamp/score_minus_81_red.png": "c448",
	"./score_stamp/score_minus_82_blue.png": "15ac",
	"./score_stamp/score_minus_82_red.png": "1961",
	"./score_stamp/score_minus_83_blue.png": "3e7b",
	"./score_stamp/score_minus_83_red.png": "ea6d",
	"./score_stamp/score_minus_84_blue.png": "64c6",
	"./score_stamp/score_minus_84_red.png": "ad18",
	"./score_stamp/score_minus_85_blue.png": "b0c8",
	"./score_stamp/score_minus_85_red.png": "1462",
	"./score_stamp/score_minus_86_blue.png": "f4f3",
	"./score_stamp/score_minus_86_red.png": "8c75",
	"./score_stamp/score_minus_87_blue.png": "620b",
	"./score_stamp/score_minus_87_red.png": "5379",
	"./score_stamp/score_minus_88_blue.png": "5cb4",
	"./score_stamp/score_minus_88_red.png": "37287",
	"./score_stamp/score_minus_89_blue.png": "0f93",
	"./score_stamp/score_minus_89_red.png": "7520",
	"./score_stamp/score_minus_8_blue.png": "68cb",
	"./score_stamp/score_minus_8_red.png": "39a8",
	"./score_stamp/score_minus_90_blue.png": "77fa",
	"./score_stamp/score_minus_90_red.png": "7dfb",
	"./score_stamp/score_minus_91_blue.png": "f5fc",
	"./score_stamp/score_minus_91_red.png": "08b7",
	"./score_stamp/score_minus_92_blue.png": "ff69",
	"./score_stamp/score_minus_92_red.png": "15cc",
	"./score_stamp/score_minus_93_blue.png": "faee",
	"./score_stamp/score_minus_93_red.png": "231d",
	"./score_stamp/score_minus_94_blue.png": "7016",
	"./score_stamp/score_minus_94_red.png": "ec17",
	"./score_stamp/score_minus_95_blue.png": "9e29",
	"./score_stamp/score_minus_95_red.png": "c7c8",
	"./score_stamp/score_minus_96_blue.png": "f64e",
	"./score_stamp/score_minus_96_red.png": "b1ad",
	"./score_stamp/score_minus_97_blue.png": "080c",
	"./score_stamp/score_minus_97_red.png": "7ec4",
	"./score_stamp/score_minus_98_blue.png": "cd17",
	"./score_stamp/score_minus_98_red.png": "8a41",
	"./score_stamp/score_minus_99_blue.png": "e6f0",
	"./score_stamp/score_minus_99_red.png": "c193",
	"./score_stamp/score_minus_9_blue.png": "2ea2",
	"./score_stamp/score_minus_9_red.png": "8438",
	"./score_stamp/score_plus_100_blue.png": "54b2",
	"./score_stamp/score_plus_100_red.png": "6c56",
	"./score_stamp/score_plus_10_blue.png": "570b",
	"./score_stamp/score_plus_10_red.png": "577e",
	"./score_stamp/score_plus_11_blue.png": "3005",
	"./score_stamp/score_plus_11_red.png": "79c0",
	"./score_stamp/score_plus_12_blue.png": "b7f7",
	"./score_stamp/score_plus_12_red.png": "9304",
	"./score_stamp/score_plus_13_blue.png": "d85e",
	"./score_stamp/score_plus_13_red.png": "9f17",
	"./score_stamp/score_plus_14_blue.png": "fe25",
	"./score_stamp/score_plus_14_red.png": "e699",
	"./score_stamp/score_plus_15_blue.png": "aeaf",
	"./score_stamp/score_plus_15_red.png": "5a1e",
	"./score_stamp/score_plus_16_blue.png": "d9f2",
	"./score_stamp/score_plus_16_red.png": "f168d",
	"./score_stamp/score_plus_17_blue.png": "f650",
	"./score_stamp/score_plus_17_red.png": "433c",
	"./score_stamp/score_plus_18_blue.png": "0700",
	"./score_stamp/score_plus_18_red.png": "c0b7",
	"./score_stamp/score_plus_19_blue.png": "0053",
	"./score_stamp/score_plus_19_red.png": "b83b",
	"./score_stamp/score_plus_1_blue.png": "ce94",
	"./score_stamp/score_plus_1_red.png": "f9b2",
	"./score_stamp/score_plus_20_blue.png": "f823",
	"./score_stamp/score_plus_20_red.png": "7728",
	"./score_stamp/score_plus_21_blue.png": "6508",
	"./score_stamp/score_plus_21_red.png": "371b",
	"./score_stamp/score_plus_22_blue.png": "fda4",
	"./score_stamp/score_plus_22_red.png": "906c",
	"./score_stamp/score_plus_23_blue.png": "b741",
	"./score_stamp/score_plus_23_red.png": "64b2",
	"./score_stamp/score_plus_24_blue.png": "ee04",
	"./score_stamp/score_plus_24_red.png": "6406",
	"./score_stamp/score_plus_25_blue.png": "c08c",
	"./score_stamp/score_plus_25_red.png": "59df",
	"./score_stamp/score_plus_26_blue.png": "7a3a",
	"./score_stamp/score_plus_26_red.png": "c674",
	"./score_stamp/score_plus_27_blue.png": "2640",
	"./score_stamp/score_plus_27_red.png": "1939",
	"./score_stamp/score_plus_28_blue.png": "c0d2",
	"./score_stamp/score_plus_28_red.png": "15c3",
	"./score_stamp/score_plus_29_blue.png": "6ed3",
	"./score_stamp/score_plus_29_red.png": "47c0",
	"./score_stamp/score_plus_2_blue.png": "eb89",
	"./score_stamp/score_plus_2_red.png": "3bb9",
	"./score_stamp/score_plus_30_blue.png": "a1ff",
	"./score_stamp/score_plus_30_red.png": "15ca",
	"./score_stamp/score_plus_31_blue.png": "644a",
	"./score_stamp/score_plus_31_red.png": "f1a4",
	"./score_stamp/score_plus_32_blue.png": "69ad",
	"./score_stamp/score_plus_32_red.png": "5237",
	"./score_stamp/score_plus_33_blue.png": "f6dd",
	"./score_stamp/score_plus_33_red.png": "bc64",
	"./score_stamp/score_plus_34_blue.png": "5999",
	"./score_stamp/score_plus_34_red.png": "0dc1",
	"./score_stamp/score_plus_35_blue.png": "3475",
	"./score_stamp/score_plus_35_red.png": "8b02",
	"./score_stamp/score_plus_36_blue.png": "ee84",
	"./score_stamp/score_plus_36_red.png": "8ef4",
	"./score_stamp/score_plus_37_blue.png": "d2c3",
	"./score_stamp/score_plus_37_red.png": "e302",
	"./score_stamp/score_plus_38_blue.png": "1201",
	"./score_stamp/score_plus_38_red.png": "e2b4",
	"./score_stamp/score_plus_39_blue.png": "ed54",
	"./score_stamp/score_plus_39_red.png": "7d7d",
	"./score_stamp/score_plus_3_blue.png": "d670",
	"./score_stamp/score_plus_3_red.png": "223f",
	"./score_stamp/score_plus_40_blue.png": "24d8",
	"./score_stamp/score_plus_40_red.png": "24c2",
	"./score_stamp/score_plus_41_blue.png": "b415",
	"./score_stamp/score_plus_41_red.png": "e41c",
	"./score_stamp/score_plus_42_blue.png": "8bbe",
	"./score_stamp/score_plus_42_red.png": "4c8c",
	"./score_stamp/score_plus_43_blue.png": "09d9",
	"./score_stamp/score_plus_43_red.png": "08c0",
	"./score_stamp/score_plus_44_blue.png": "2277",
	"./score_stamp/score_plus_44_red.png": "9272",
	"./score_stamp/score_plus_45_blue.png": "0918",
	"./score_stamp/score_plus_45_red.png": "2b87",
	"./score_stamp/score_plus_46_blue.png": "1873",
	"./score_stamp/score_plus_46_red.png": "61e7",
	"./score_stamp/score_plus_47_blue.png": "aece",
	"./score_stamp/score_plus_47_red.png": "5716",
	"./score_stamp/score_plus_48_blue.png": "8f46",
	"./score_stamp/score_plus_48_red.png": "4578",
	"./score_stamp/score_plus_49_blue.png": "5116",
	"./score_stamp/score_plus_49_red.png": "8cb5",
	"./score_stamp/score_plus_4_blue.png": "3180",
	"./score_stamp/score_plus_4_red.png": "63f6",
	"./score_stamp/score_plus_50_blue.png": "ca85",
	"./score_stamp/score_plus_50_red.png": "f205",
	"./score_stamp/score_plus_51_blue.png": "c2ec",
	"./score_stamp/score_plus_51_red.png": "e996",
	"./score_stamp/score_plus_52_blue.png": "19a0",
	"./score_stamp/score_plus_52_red.png": "4d37",
	"./score_stamp/score_plus_53_blue.png": "ce75",
	"./score_stamp/score_plus_53_red.png": "a14b",
	"./score_stamp/score_plus_54_blue.png": "3b42",
	"./score_stamp/score_plus_54_red.png": "555b",
	"./score_stamp/score_plus_55_blue.png": "f052",
	"./score_stamp/score_plus_55_red.png": "7163",
	"./score_stamp/score_plus_56_blue.png": "39e7",
	"./score_stamp/score_plus_56_red.png": "1c51",
	"./score_stamp/score_plus_57_blue.png": "73fa",
	"./score_stamp/score_plus_57_red.png": "dddb",
	"./score_stamp/score_plus_58_blue.png": "fbdd",
	"./score_stamp/score_plus_58_red.png": "039c",
	"./score_stamp/score_plus_59_blue.png": "8f57",
	"./score_stamp/score_plus_59_red.png": "aea4",
	"./score_stamp/score_plus_5_blue.png": "c063",
	"./score_stamp/score_plus_5_red.png": "db98",
	"./score_stamp/score_plus_60_blue.png": "b6ea",
	"./score_stamp/score_plus_60_red.png": "66af",
	"./score_stamp/score_plus_61_blue.png": "9051",
	"./score_stamp/score_plus_61_red.png": "3b5a",
	"./score_stamp/score_plus_62_blue.png": "efdd",
	"./score_stamp/score_plus_62_red.png": "4ca9",
	"./score_stamp/score_plus_63_blue.png": "bd95",
	"./score_stamp/score_plus_63_red.png": "8859",
	"./score_stamp/score_plus_64_blue.png": "e60f",
	"./score_stamp/score_plus_64_red.png": "b4a1",
	"./score_stamp/score_plus_65_blue.png": "8657",
	"./score_stamp/score_plus_65_red.png": "f6df",
	"./score_stamp/score_plus_66_blue.png": "7509",
	"./score_stamp/score_plus_66_red.png": "be23",
	"./score_stamp/score_plus_67_blue.png": "0165",
	"./score_stamp/score_plus_67_red.png": "c575",
	"./score_stamp/score_plus_68_blue.png": "12de",
	"./score_stamp/score_plus_68_red.png": "e5d6",
	"./score_stamp/score_plus_69_blue.png": "e6f00",
	"./score_stamp/score_plus_69_red.png": "3940",
	"./score_stamp/score_plus_6_blue.png": "7dd6",
	"./score_stamp/score_plus_6_red.png": "6726",
	"./score_stamp/score_plus_70_blue.png": "80d2",
	"./score_stamp/score_plus_70_red.png": "1ada",
	"./score_stamp/score_plus_71_blue.png": "f017",
	"./score_stamp/score_plus_71_red.png": "9e2f",
	"./score_stamp/score_plus_72_blue.png": "6de7",
	"./score_stamp/score_plus_72_red.png": "d86d",
	"./score_stamp/score_plus_73_blue.png": "0cde",
	"./score_stamp/score_plus_73_red.png": "7249",
	"./score_stamp/score_plus_74_blue.png": "a726",
	"./score_stamp/score_plus_74_red.png": "c432",
	"./score_stamp/score_plus_75_blue.png": "e979",
	"./score_stamp/score_plus_75_red.png": "eaf7",
	"./score_stamp/score_plus_76_blue.png": "e0e9",
	"./score_stamp/score_plus_76_red.png": "cd5e",
	"./score_stamp/score_plus_77_blue.png": "d617",
	"./score_stamp/score_plus_77_red.png": "a394",
	"./score_stamp/score_plus_78_blue.png": "ae43",
	"./score_stamp/score_plus_78_red.png": "279d",
	"./score_stamp/score_plus_79_blue.png": "8c04",
	"./score_stamp/score_plus_79_red.png": "4247",
	"./score_stamp/score_plus_7_blue.png": "d416",
	"./score_stamp/score_plus_7_red.png": "7650",
	"./score_stamp/score_plus_80_blue.png": "4115",
	"./score_stamp/score_plus_80_red.png": "ff36",
	"./score_stamp/score_plus_81_blue.png": "5278",
	"./score_stamp/score_plus_81_red.png": "6ba1",
	"./score_stamp/score_plus_82_blue.png": "b356",
	"./score_stamp/score_plus_82_red.png": "fae4",
	"./score_stamp/score_plus_83_blue.png": "9830",
	"./score_stamp/score_plus_83_red.png": "ec07",
	"./score_stamp/score_plus_84_blue.png": "fa30",
	"./score_stamp/score_plus_84_red.png": "491d",
	"./score_stamp/score_plus_85_blue.png": "40a7",
	"./score_stamp/score_plus_85_red.png": "aa61",
	"./score_stamp/score_plus_86_blue.png": "3aaf",
	"./score_stamp/score_plus_86_red.png": "381f",
	"./score_stamp/score_plus_87_blue.png": "b02b",
	"./score_stamp/score_plus_87_red.png": "5574",
	"./score_stamp/score_plus_88_blue.png": "4481",
	"./score_stamp/score_plus_88_red.png": "2e0d",
	"./score_stamp/score_plus_89_blue.png": "9665",
	"./score_stamp/score_plus_89_red.png": "8663",
	"./score_stamp/score_plus_8_blue.png": "09ea",
	"./score_stamp/score_plus_8_red.png": "9eb1",
	"./score_stamp/score_plus_90_blue.png": "9a22",
	"./score_stamp/score_plus_90_red.png": "753b",
	"./score_stamp/score_plus_91_blue.png": "aca4",
	"./score_stamp/score_plus_91_red.png": "b22a",
	"./score_stamp/score_plus_92_blue.png": "d79c",
	"./score_stamp/score_plus_92_red.png": "befd",
	"./score_stamp/score_plus_93_blue.png": "262b",
	"./score_stamp/score_plus_93_red.png": "93de",
	"./score_stamp/score_plus_94_blue.png": "84a4",
	"./score_stamp/score_plus_94_red.png": "49ba",
	"./score_stamp/score_plus_95_blue.png": "5a02",
	"./score_stamp/score_plus_95_red.png": "c5bb",
	"./score_stamp/score_plus_96_blue.png": "6903",
	"./score_stamp/score_plus_96_red.png": "b36c",
	"./score_stamp/score_plus_97_blue.png": "089c",
	"./score_stamp/score_plus_97_red.png": "5fe8",
	"./score_stamp/score_plus_98_blue.png": "4599",
	"./score_stamp/score_plus_98_red.png": "bbdc",
	"./score_stamp/score_plus_99_blue.png": "cae1",
	"./score_stamp/score_plus_99_red.png": "dec5",
	"./score_stamp/score_plus_9_blue.png": "309e",
	"./score_stamp/score_plus_9_red.png": "6f39",
	"./scoring_mark/batsu_#000000.png": "b60a",
	"./scoring_mark/batsu_#0000ff.png": "ae8b",
	"./scoring_mark/batsu_#00ff00.png": "9eaf",
	"./scoring_mark/batsu_#00ffff.png": "dda8",
	"./scoring_mark/batsu_#073763.png": "58a7",
	"./scoring_mark/batsu_#0b5394.png": "381a",
	"./scoring_mark/batsu_#0c343d.png": "84a2",
	"./scoring_mark/batsu_#1155cc.png": "f518",
	"./scoring_mark/batsu_#134f5c.png": "48fe",
	"./scoring_mark/batsu_#1c4587.png": "d476",
	"./scoring_mark/batsu_#20124d.png": "faa1",
	"./scoring_mark/batsu_#274e13.png": "6b13",
	"./scoring_mark/batsu_#351c75.png": "87bc",
	"./scoring_mark/batsu_#38761d.png": "0b83",
	"./scoring_mark/batsu_#3c78d8.png": "901f",
	"./scoring_mark/batsu_#3d85c6.png": "d566",
	"./scoring_mark/batsu_#434343.png": "417b",
	"./scoring_mark/batsu_#45818e.png": "aef0",
	"./scoring_mark/batsu_#4a86e8.png": "403e",
	"./scoring_mark/batsu_#4c1130.png": "c562",
	"./scoring_mark/batsu_#5b0f00.png": "67b9",
	"./scoring_mark/batsu_#660000.png": "822d",
	"./scoring_mark/batsu_#666666.png": "557a",
	"./scoring_mark/batsu_#674ea7.png": "5982",
	"./scoring_mark/batsu_#6aa84f.png": "54d4",
	"./scoring_mark/batsu_#6d9eeb.png": "0f86",
	"./scoring_mark/batsu_#6fa8dc.png": "9bc3",
	"./scoring_mark/batsu_#741b47.png": "dfe4",
	"./scoring_mark/batsu_#76a5af.png": "541d",
	"./scoring_mark/batsu_#783f04.png": "46d5",
	"./scoring_mark/batsu_#7f6000.png": "1d53",
	"./scoring_mark/batsu_#85200c.png": "96a5",
	"./scoring_mark/batsu_#8e7cc3.png": "8ed8",
	"./scoring_mark/batsu_#93c47d.png": "d063",
	"./scoring_mark/batsu_#980000.png": "a0aa",
	"./scoring_mark/batsu_#990000.png": "5e36",
	"./scoring_mark/batsu_#9900ff.png": "92c6",
	"./scoring_mark/batsu_#999999.png": "4bf6",
	"./scoring_mark/batsu_#9fc5e8.png": "fa35",
	"./scoring_mark/batsu_#a2c4c9.png": "9892",
	"./scoring_mark/batsu_#a4c2f4.png": "5b68",
	"./scoring_mark/batsu_#a61c00.png": "10bf",
	"./scoring_mark/batsu_#a64d79.png": "4aaf",
	"./scoring_mark/batsu_#b45f06.png": "d0e0",
	"./scoring_mark/batsu_#b4a7d6.png": "cfff",
	"./scoring_mark/batsu_#b6d7a8.png": "46e8",
	"./scoring_mark/batsu_#b7b7b7.png": "4388",
	"./scoring_mark/batsu_#bf9000.png": "156a",
	"./scoring_mark/batsu_#c27ba0.png": "ce19",
	"./scoring_mark/batsu_#c9daf8.png": "e4807",
	"./scoring_mark/batsu_#cc0000.png": "776c",
	"./scoring_mark/batsu_#cc4125.png": "2d0a",
	"./scoring_mark/batsu_#cccccc.png": "d145",
	"./scoring_mark/batsu_#cfe2f3.png": "1296",
	"./scoring_mark/batsu_#d0e0e3.png": "fc51",
	"./scoring_mark/batsu_#d5a6bd.png": "5843",
	"./scoring_mark/batsu_#d9d2e9.png": "764e",
	"./scoring_mark/batsu_#d9d9d9.png": "6f74",
	"./scoring_mark/batsu_#d9ead3.png": "7862",
	"./scoring_mark/batsu_#dd7e6b.png": "6bb2",
	"./scoring_mark/batsu_#e06666.png": "5283",
	"./scoring_mark/batsu_#e69138.png": "e2ae",
	"./scoring_mark/batsu_#e6b8af.png": "8fb3",
	"./scoring_mark/batsu_#ea9999.png": "8f0d",
	"./scoring_mark/batsu_#ead1dc.png": "9bef",
	"./scoring_mark/batsu_#efefef.png": "349a",
	"./scoring_mark/batsu_#f1c232.png": "2351",
	"./scoring_mark/batsu_#f3f3f3.png": "a31f",
	"./scoring_mark/batsu_#f4cccc.png": "63b5",
	"./scoring_mark/batsu_#f6b26b.png": "d8a8",
	"./scoring_mark/batsu_#f9cb9c.png": "275d",
	"./scoring_mark/batsu_#fce5cd.png": "d107",
	"./scoring_mark/batsu_#ff0000.png": "f486",
	"./scoring_mark/batsu_#ff00ff.png": "6879",
	"./scoring_mark/batsu_#ff9900.png": "7ee3",
	"./scoring_mark/batsu_#ffd966.png": "dd97",
	"./scoring_mark/batsu_#ffe599.png": "b04b",
	"./scoring_mark/batsu_#fff2cc.png": "ac5b",
	"./scoring_mark/batsu_#ffff00.png": "dba4",
	"./scoring_mark/batsu_#ffffff.png": "0bda",
	"./scoring_mark/maru_#000000.png": "0936",
	"./scoring_mark/maru_#0000ff.png": "c308",
	"./scoring_mark/maru_#00ff00.png": "02ea",
	"./scoring_mark/maru_#00ffff.png": "9077",
	"./scoring_mark/maru_#073763.png": "b9d9",
	"./scoring_mark/maru_#0b5394.png": "8691",
	"./scoring_mark/maru_#0c343d.png": "f1dc",
	"./scoring_mark/maru_#1155cc.png": "3efc",
	"./scoring_mark/maru_#134f5c.png": "d223",
	"./scoring_mark/maru_#1c4587.png": "2373",
	"./scoring_mark/maru_#20124d.png": "792e",
	"./scoring_mark/maru_#274e13.png": "016e",
	"./scoring_mark/maru_#351c75.png": "3694",
	"./scoring_mark/maru_#38761d.png": "4863",
	"./scoring_mark/maru_#3c78d8.png": "f919",
	"./scoring_mark/maru_#3d85c6.png": "a5e5",
	"./scoring_mark/maru_#434343.png": "198d",
	"./scoring_mark/maru_#45818e.png": "1044",
	"./scoring_mark/maru_#4a86e8.png": "29547",
	"./scoring_mark/maru_#4c1130.png": "8bd8",
	"./scoring_mark/maru_#5b0f00.png": "a33f",
	"./scoring_mark/maru_#660000.png": "cca6",
	"./scoring_mark/maru_#666666.png": "7b0a",
	"./scoring_mark/maru_#674ea7.png": "c402",
	"./scoring_mark/maru_#6aa84f.png": "6ed3c",
	"./scoring_mark/maru_#6d9eeb.png": "eca1",
	"./scoring_mark/maru_#6fa8dc.png": "e6e5",
	"./scoring_mark/maru_#741b47.png": "472c",
	"./scoring_mark/maru_#76a5af.png": "a784",
	"./scoring_mark/maru_#783f04.png": "cf6b",
	"./scoring_mark/maru_#7f6000.png": "bc30",
	"./scoring_mark/maru_#85200c.png": "511e",
	"./scoring_mark/maru_#8e7cc3.png": "3468",
	"./scoring_mark/maru_#93c47d.png": "a3e7",
	"./scoring_mark/maru_#980000.png": "0512",
	"./scoring_mark/maru_#990000.png": "70879",
	"./scoring_mark/maru_#9900ff.png": "a2aa",
	"./scoring_mark/maru_#999999.png": "002f",
	"./scoring_mark/maru_#9fc5e8.png": "6cef",
	"./scoring_mark/maru_#a2c4c9.png": "6a16",
	"./scoring_mark/maru_#a4c2f4.png": "adf9",
	"./scoring_mark/maru_#a61c00.png": "d285",
	"./scoring_mark/maru_#a64d79.png": "6ce4",
	"./scoring_mark/maru_#b45f06.png": "4dc9",
	"./scoring_mark/maru_#b4a7d6.png": "95fa",
	"./scoring_mark/maru_#b6d7a8.png": "0deb",
	"./scoring_mark/maru_#b7b7b7.png": "4349",
	"./scoring_mark/maru_#bf9000.png": "b939",
	"./scoring_mark/maru_#c27ba0.png": "01bc",
	"./scoring_mark/maru_#c9daf8.png": "3d4d",
	"./scoring_mark/maru_#cc0000.png": "07a7",
	"./scoring_mark/maru_#cc4125.png": "afc9",
	"./scoring_mark/maru_#cccccc.png": "41a1",
	"./scoring_mark/maru_#cfe2f3.png": "35a8",
	"./scoring_mark/maru_#d0e0e3.png": "e43b",
	"./scoring_mark/maru_#d5a6bd.png": "4b71",
	"./scoring_mark/maru_#d9d2e9.png": "fbdd2",
	"./scoring_mark/maru_#d9d9d9.png": "9b1c",
	"./scoring_mark/maru_#d9ead3.png": "86f3",
	"./scoring_mark/maru_#dd7e6b.png": "552b",
	"./scoring_mark/maru_#e06666.png": "2b2f",
	"./scoring_mark/maru_#e69138.png": "f5b2",
	"./scoring_mark/maru_#e6b8af.png": "8132",
	"./scoring_mark/maru_#ea9999.png": "f935",
	"./scoring_mark/maru_#ead1dc.png": "4db7",
	"./scoring_mark/maru_#efefef.png": "b315",
	"./scoring_mark/maru_#f1c232.png": "0e90",
	"./scoring_mark/maru_#f3f3f3.png": "56c8",
	"./scoring_mark/maru_#f4cccc.png": "456c",
	"./scoring_mark/maru_#f6b26b.png": "af5f",
	"./scoring_mark/maru_#f9cb9c.png": "7064",
	"./scoring_mark/maru_#fce5cd.png": "edaf",
	"./scoring_mark/maru_#ff0000.png": "3980",
	"./scoring_mark/maru_#ff00ff.png": "eda3",
	"./scoring_mark/maru_#ff9900.png": "d92d",
	"./scoring_mark/maru_#ffd966.png": "d453",
	"./scoring_mark/maru_#ffe599.png": "1cd4",
	"./scoring_mark/maru_#fff2cc.png": "9409",
	"./scoring_mark/maru_#ffff00.png": "8400",
	"./scoring_mark/maru_#ffffff.png": "374a",
	"./scoring_mark/sankaku_#000000.png": "fea3",
	"./scoring_mark/sankaku_#0000ff.png": "eb92",
	"./scoring_mark/sankaku_#00ff00.png": "b06e",
	"./scoring_mark/sankaku_#00ffff.png": "5f4a",
	"./scoring_mark/sankaku_#073763.png": "df6a",
	"./scoring_mark/sankaku_#0b5394.png": "03a4",
	"./scoring_mark/sankaku_#0c343d.png": "1965",
	"./scoring_mark/sankaku_#1155cc.png": "e103",
	"./scoring_mark/sankaku_#134f5c.png": "3e44",
	"./scoring_mark/sankaku_#1c4587.png": "87c6",
	"./scoring_mark/sankaku_#20124d.png": "3e8a",
	"./scoring_mark/sankaku_#274e13.png": "1600",
	"./scoring_mark/sankaku_#351c75.png": "e617",
	"./scoring_mark/sankaku_#38761d.png": "55be",
	"./scoring_mark/sankaku_#3c78d8.png": "2f11",
	"./scoring_mark/sankaku_#3d85c6.png": "6f4d",
	"./scoring_mark/sankaku_#434343.png": "1665",
	"./scoring_mark/sankaku_#45818e.png": "d63a",
	"./scoring_mark/sankaku_#4a86e8.png": "08b1",
	"./scoring_mark/sankaku_#4c1130.png": "8f05",
	"./scoring_mark/sankaku_#5b0f00.png": "aea8",
	"./scoring_mark/sankaku_#660000.png": "d21c",
	"./scoring_mark/sankaku_#666666.png": "c6c0",
	"./scoring_mark/sankaku_#674ea7.png": "4937",
	"./scoring_mark/sankaku_#6aa84f.png": "ee01",
	"./scoring_mark/sankaku_#6d9eeb.png": "5d0c",
	"./scoring_mark/sankaku_#6fa8dc.png": "ff5b",
	"./scoring_mark/sankaku_#741b47.png": "6057",
	"./scoring_mark/sankaku_#76a5af.png": "8d90",
	"./scoring_mark/sankaku_#783f04.png": "efbe",
	"./scoring_mark/sankaku_#7f6000.png": "0027",
	"./scoring_mark/sankaku_#85200c.png": "7ec2",
	"./scoring_mark/sankaku_#8e7cc3.png": "ed9e",
	"./scoring_mark/sankaku_#93c47d.png": "ebc8",
	"./scoring_mark/sankaku_#980000.png": "8be7",
	"./scoring_mark/sankaku_#990000.png": "14bf",
	"./scoring_mark/sankaku_#9900ff.png": "95d23",
	"./scoring_mark/sankaku_#999999.png": "71b2",
	"./scoring_mark/sankaku_#9fc5e8.png": "7dfc",
	"./scoring_mark/sankaku_#a2c4c9.png": "3181",
	"./scoring_mark/sankaku_#a4c2f4.png": "835e",
	"./scoring_mark/sankaku_#a61c00.png": "98ae",
	"./scoring_mark/sankaku_#a64d79.png": "ca1d",
	"./scoring_mark/sankaku_#b45f06.png": "9394",
	"./scoring_mark/sankaku_#b4a7d6.png": "d93a",
	"./scoring_mark/sankaku_#b6d7a8.png": "59fe",
	"./scoring_mark/sankaku_#b7b7b7.png": "0c8f",
	"./scoring_mark/sankaku_#bf9000.png": "5242",
	"./scoring_mark/sankaku_#c27ba0.png": "5d22",
	"./scoring_mark/sankaku_#c9daf8.png": "bf24",
	"./scoring_mark/sankaku_#cc0000.png": "4e8c",
	"./scoring_mark/sankaku_#cc4125.png": "cb61",
	"./scoring_mark/sankaku_#cccccc.png": "1fef",
	"./scoring_mark/sankaku_#cfe2f3.png": "537a",
	"./scoring_mark/sankaku_#d0e0e3.png": "b1fd",
	"./scoring_mark/sankaku_#d5a6bd.png": "711a",
	"./scoring_mark/sankaku_#d9d2e9.png": "5596",
	"./scoring_mark/sankaku_#d9d9d9.png": "8209",
	"./scoring_mark/sankaku_#d9ead3.png": "a124",
	"./scoring_mark/sankaku_#dd7e6b.png": "679e",
	"./scoring_mark/sankaku_#e06666.png": "5d85",
	"./scoring_mark/sankaku_#e69138.png": "ce16",
	"./scoring_mark/sankaku_#e6b8af.png": "6f5f",
	"./scoring_mark/sankaku_#ea9999.png": "51dd",
	"./scoring_mark/sankaku_#ead1dc.png": "19dd",
	"./scoring_mark/sankaku_#efefef.png": "039c6",
	"./scoring_mark/sankaku_#f1c232.png": "3a82",
	"./scoring_mark/sankaku_#f3f3f3.png": "c7fa",
	"./scoring_mark/sankaku_#f4cccc.png": "7520a",
	"./scoring_mark/sankaku_#f6b26b.png": "4983",
	"./scoring_mark/sankaku_#f9cb9c.png": "51c4",
	"./scoring_mark/sankaku_#fce5cd.png": "7376",
	"./scoring_mark/sankaku_#ff0000.png": "20de",
	"./scoring_mark/sankaku_#ff00ff.png": "3a2d",
	"./scoring_mark/sankaku_#ff9900.png": "ac96",
	"./scoring_mark/sankaku_#ffd966.png": "dca3",
	"./scoring_mark/sankaku_#ffe599.png": "2922",
	"./scoring_mark/sankaku_#fff2cc.png": "79ae",
	"./scoring_mark/sankaku_#ffff00.png": "ddb6",
	"./scoring_mark/sankaku_#ffffff.png": "aa81",
	"./tate.png": "bc36",
	"./unscoring.png": "b216",
	"./yoko.png": "2dc1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";